<h2 mat-dialog-title>Add to {{ data.tableName }}</h2>

<mat-dialog-content>
  <ng-container *ngFor="let col of editableColumns">

    <!-- Non-boolean fields: text / number / textarea / select -->
    <mat-form-field
      *ngIf="col.type !== 'boolean'"
      appearance="outline"
      class="full-width dialog-field">
      <!-- Material renders the required asterisk automatically from [required];
           no manual asterisk (avoids a double **). -->
      <mat-label>{{ col.label }}</mat-label>

      <input
        matInput
        *ngIf="col.type === 'text'"
        [(ngModel)]="row[col.field]"
        [required]="!!col.required"
        [attr.maxlength]="col.maxLength ?? null" />

      <input
        matInput
        type="number"
        *ngIf="col.type === 'number'"
        [(ngModel)]="row[col.field]"
        [required]="!!col.required" />

      <textarea
        matInput
        *ngIf="col.type === 'textarea'"
        [(ngModel)]="row[col.field]"
        [required]="!!col.required"
        [attr.maxlength]="col.maxLength ?? null"
        rows="3"></textarea>

      <mat-select *ngIf="col.type === 'select'" [(ngModel)]="row[col.field]" [required]="!!col.required">
        <mat-option *ngFor="let opt of col.selectOptions" [value]="opt.value">
          {{ opt.label }}
        </mat-option>
      </mat-select>

    </mat-form-field>

    <!-- Boolean field: slide toggle outside form-field -->
    <div *ngIf="col.type === 'boolean'" class="boolean-field">
      <mat-slide-toggle [(ngModel)]="row[col.field]">{{ col.label }}</mat-slide-toggle>
    </div>

  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="br-btn br-btn--ghost" (click)="cancel()">Cancel</button>
  <button type="button" class="br-btn br-btn--primary" [disabled]="!isValid()" (click)="save()">Save</button>
</mat-dialog-actions>
